import { CALENDAR_DAY_END_HOUR, CALENDAR_DAY_START_HOUR, SLOT_HEIGHT, TASK_DAY_OFF_TYPE } from "./Constants";


export const calculatePositionFromTime = time => {
  const startHour = time.getHours();
  const startMinutes = time.getMinutes();
  const totalMinutesStart = (startHour - CALENDAR_DAY_START_HOUR) * 60 + startMinutes;
  const top = (totalMinutesStart / 30) * (SLOT_HEIGHT / 2);
  return top;
};

export const calculateTaskPosition = task => {
  const dayOff = task.kind === TASK_DAY_OFF_TYPE;
  const startTop = dayOff ? 0 : calculatePositionFromTime(task.start);
  const endTop = dayOff ? (CALENDAR_DAY_END_HOUR - CALENDAR_DAY_START_HOUR) * SLOT_HEIGHT : calculatePositionFromTime(task.end);
  const height = endTop - startTop;
  return { top: startTop, height };
};

export const formatTimeOnly = date => {
  const hours = String(date.getHours());
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const formatDateOnly = date => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const isToday = (day) => {
  const date = new Date();
  return day.getMonth() === date.getMonth() && day.getDate() === date.getDate() && day.getFullYear() === date.getFullYear();
};

export const startEndDayMonthYear = task => {
  const start = new Date(task.time_from);
  const end = new Date(task.time_to);
  const day = start.getDate();
  const month = start.getMonth();
  const year = start.getFullYear();
  return { start, end, day, month, year };
};

export const getStartOfWeek = date => {
  const weekStart = new Date(date);
  weekStart.setDate(date.getDate() - date.getDay() + 1); // Adjust to the nearest Sunday
  weekStart.setHours(0, 0, 0, 0); // Set time to midnight
  return weekStart;
};

export const iterateDays = (start, days) => {
  const dates = [];
  let current = new Date(start);
  for (let i = 0; i < days; i++) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1); // Move to the next day
  }
  return dates;
};

export const truncateStrMiddle = (str, maxLength) => {
  if (str.length <= maxLength) return str;
  const start = str.slice(0, Math.ceil(maxLength / 2) - 2);
  const end = str.slice(-Math.floor(maxLength / 2) + 2);
  return `${start}...${end}`;
};



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/Utils.js